import React from 'react';
import { ShieldCheck, Lock, UserCheck, Prohibit } from '@phosphor-icons/react';

const BADGES = [
  { icon: <Lock size={11} weight="fill" />, label: 'Secure payment' },
  { icon: <UserCheck size={11} weight="fill" />, label: 'Verified providers' },
  { icon: <Prohibit size={11} weight="fill" />, label: 'No off-platform risk' },
  { icon: <ShieldCheck size={11} weight="fill" />, label: 'Protected booking' },
];

// Inline horizontal bar — light bg
export function TrustBar({ className = '' }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 py-2.5 ${className}`} data-testid="trust-bar">
      {BADGES.map((b, i) => (
        <span key={i} className="flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground">
          <span className="text-primary">{b.icon}</span>
          {b.label}
        </span>
      ))}
    </div>
  );
}

// Compact strip for cards/forms — border top
export function TrustStrip({ className = '' }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 border-t border-border/70 pt-2.5 mt-3 ${className}`} data-testid="trust-strip">
      {BADGES.map((b, i) => (
        <span key={i} className="flex items-center gap-1 text-[10px] text-muted-foreground">
          <span className="text-primary">{b.icon}</span> {b.label}
        </span>
      ))}
    </div>
  );
}

// Dark variant for dark sections
export function TrustBarDark({ className = '' }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 py-2.5 ${className}`} data-testid="trust-bar-dark">
      {BADGES.map((b, i) => (
        <span key={i} className="flex items-center gap-1.5 text-[11px] font-medium text-background/70">
          <span className="text-primary-foreground/90">{b.icon}</span>
          {b.label}
        </span>
      ))}
    </div>
  );
}

// Mini badge — single line for tight spaces
export function TrustMini({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="trust-mini">
      <span className="flex items-center gap-1 text-[10px] text-muted-foreground"><Lock size={9} weight="fill" className="text-primary" /> Secure</span>
      <span className="flex items-center gap-1 text-[10px] text-muted-foreground"><UserCheck size={9} weight="fill" className="text-primary" /> Verified</span>
      <span className="flex items-center gap-1 text-[10px] text-muted-foreground"><ShieldCheck size={9} weight="fill" className="text-primary" /> Protected</span>
    </div>
  );
}
